import { AppShell } from '../components/AppShell'

const SECTIONS = [
  { title: 'Trading risks & variance',
    body: 'Sports betting outcomes carry inherent variance. Past performance does not guarantee future results. A skilled bettor with positive expected value (EV) can still experience extended losing streaks. By participating in a RivalProp challenge, you acknowledge this variance and agree that intermediate results may not reflect long-term skill.' },
  { title: 'Capital allocation & the funded program',
    body: 'Challenge fees are non-refundable upon attempt. Funded accounts grant access to RivalProp capital under defined risk controls. RivalProp retains full custody of all trading capital; your performance fee is paid out per cycle subject to cycle terms. We are not a bank and the funds are not deposits.' },
  { title: 'Eligibility & jurisdiction',
    body: 'You must be at least 18 years old (or the legal age in your jurisdiction) and not be located in a restricted country. It is your responsibility to ensure that participating in skill-based betting markets is legal in your jurisdiction. RivalProp may suspend or close accounts at any time if compliance concerns arise.' },
  { title: 'Behavioural risk',
    body: 'If you find yourself betting more than you intend, chasing losses, or experiencing distress related to betting outcomes, please pause and seek support. Self-exclusion is available from your account settings. Helplines: BeGambleAware (UK), GamCare (UK), 1‑800‑GAMBLER (US).' },
]

export function RiskDisclosurePage() {
  return (
    <AppShell page="help" breadcrumb={<span className="topbar__breadcrumb-current">Risk Disclosure</span>}>
      <header className="page-header">
        <div className="page-header__main">
          <p className="page-header__eyebrow"><span>Legal</span></p>
          <h1 className="page-header__title">Risk Disclosure</h1>
          <p className="page-header__subtitle">Read this before participating in a challenge. Last updated: May 2026.</p>
        </div>
      </header>

      <div className="legal-doc">
        {SECTIONS.map((s, i) => (
          <div key={s.title} className="legal-doc__section">
            <span className="legal-doc__section-num">Section {i + 1}</span>
            <h2 className="legal-doc__section-title">{s.title}</h2>
            <p className="legal-doc__body">{s.body}</p>
          </div>
        ))}
        <div className="legal-doc__footer">
          <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-tertiary)' }}>
            This is a placeholder document. The final risk disclosure will be drafted by counsel and replace this content.
          </p>
        </div>
      </div>
    </AppShell>
  )
}
